import React from "react";
import { useFrame } from "react-three-fiber";
import { Box } from "./Box";
import { VantagePoint } from "./VantagePoint";

const COLOR = 0xFFFFFF;

interface ReverbSceneProps {
  size: [width: number, height: number, depth: number];
  listenerPosition: [x: number, y: number, z: number];
}
export const ReverbScene: React.FC<ReverbSceneProps> = ({
  size,
  listenerPosition,
}) => {
  useFrame(({ camera, clock }) => {
    camera.position.x = 6 * Math.cos(clock.elapsedTime / 6);
    camera.position.z = 6 * Math.sin(clock.elapsedTime / 6);
    camera.position.y = 3;
    camera.lookAt(0, 0, 0);
  });

  return (
    <group position={[0, 1, 0]}>
      <Box width={size[0]} height={size[1]} depth={size[2]} lineWidth={0.01} lineColor={COLOR} />
      <VantagePoint position={listenerPosition} floor={-size[1] / 2} color={COLOR} />
    </group>
  );
};
